import { render, staticRenderFns } from "./CompleteTaskList.vue?vue&type=template&id=5d1cf242&"
import script from "./CompleteTaskList.vue?vue&type=script&lang=js&"
export * from "./CompleteTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports